import { Typography } from '@mui/material';
import { Dialog } from '@components';
import { Dispatch, SetStateAction } from 'react';
import { deleteOperationIncidentNote, OperationIncidentNote } from '../../../../networkRequest/operationsService';
import { useUser } from '../../../../hooks/useUser';

interface DeleteIncidentNoteDialogProps {
  open: boolean;
  onClose: () => void;
  onDelete: (noteId: string) => void;
  selectedIncidentNote: OperationIncidentNote | null;
  setSelectedIncidentNote: Dispatch<SetStateAction<OperationIncidentNote | null>>;
  setError: Dispatch<SetStateAction<string | null>>;
}

const DeleteIncidentNoteDialog = ({
  open,
  onClose,
  onDelete,
  selectedIncidentNote,
  setSelectedIncidentNote,
  setError
}: DeleteIncidentNoteDialogProps) => {
  const { user } = useUser();

  const handleCancel = () => {
    setSelectedIncidentNote(null);
    onClose();
  };

  const handleDelete = async () => {
    if (!selectedIncidentNote || !user) {
      return;
    }

    const { error } = await deleteOperationIncidentNote({
      accessToken: user.accessToken,
      noteId: selectedIncidentNote.id
    });

    if (error) {
      setError(error);
      return;
    }

    onDelete(selectedIncidentNote.id);
    setSelectedIncidentNote(null);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      showClose={false}
      primaryButtonText='Delete'
      primaryButtonAction={handleDelete}
      secondaryButtonText='Cancel'
      fullWidth={false}
    >
      <Typography variant='h5'>Delete Incident Note?</Typography>
      <Typography sx={{
        mt: '8px'
      }}>This incident note will be removed from the list.</Typography>
    </Dialog>
  );
};

export default DeleteIncidentNoteDialog;